import React from 'react'
import notFound from './assets/404.png'
import { Image, Divider, Header } from 'semantic-ui-react'



const NotFoundPage = () => {
  return  <div>
    <Divider hidden />
    <Divider hidden />
    <Image src={notFound} />
    <Header textAlign='center' size='large'>Page does not exist.</Header>
    <Header textAlign='center' size='large'>Start your journey from <a href='/'>Home</a></Header>
    <Divider hidden />
    <Divider hidden />
  </div>
}

export default NotFoundPage



// WEBPACK FOOTER //
// ./src/pages/404.js